import React, {useEffect, useState} from 'react';
import {Box, FormControlLabel, Checkbox, LinearProgress, CircularProgress} from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import {useRecoilState, useRecoilValue} from 'recoil';
import * as repo from "../../stores/repositories";
import { buildMobileDialogMessage, MOBILE_DIALOG_TYPE} from "../../utils/mobileCommunication";
import AxlDialog from '../../components/AxlDialog';
import { setAgreements } from '../../atoms/agreements/selector';
import { CONTRACT_STATUS, CONTRACT_TYPE } from '../../constants/contract';
import { URL_PARAMS } from '../../constants/urlParams/urlParams';
import { filterTemplate } from '../../utils/filterTemplate';
import {createUrlParams} from "../../utils/urlParams";
import {appState} from "../../atoms/agreements/state";
import {PDFViewer} from "../../components/PDFViewer";
import {
  StyledContainer,
  StyledActions,
  StyledAgreeButton,
  StyledTypoCongratulations
} from "./styles";

let cloneTemplates = [];

function Documentation(props) {
  const {contract, isFinal, groupIds, submitCallback} = props;
  const {id} = useParams();
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState({});
  const [checked, setChecked] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [isCongratulations, setIsCongratulations] = useState(false);
  const [agreement, setAgreement] = useRecoilState(setAgreements);
  const apps = useRecoilValue(appState)
  const [message, setMessage] = useState(null);
  const [pdfLoaded, setPdfLoaded] = useState(false);
  cloneTemplates = _.cloneDeep(agreement?.templates);

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get(URL_PARAMS.TOKEN);
  const redirectTo = urlParams.get('redirect_to');

  useEffect(() => {
    if (!!id && !contract) {
      setLoading(true);
      repo.getTemplate(id, token, {}).then(res => {
        if (res.ok) {
          setTemplate(res.data);
        } else {
          setTemplate({});
          setError(res.data ? res.data.message : "Error while sent request");
        }
        setLoading(false);
      })
    } else {
      setTemplate(contract);
    }
  }, []);

  useEffect(() => {
    setTemplate(contract);
  }, [contract]);

  const isAgree = () => {
    return !template.checkboxes?.length || template.checkboxes.length === checked.length;
  }

  const handleCheckbox = (e, i) => {
    const checkedSet = new Set(checked);
    if (e.target.checked) {
      checkedSet.add(i);
    } else {
      checkedSet.delete(i);
    }
    setChecked(Array.from(checkedSet));
  }

  const onSubmit = () => {
    if (isAgree()) {
      const urlIsFinal = cloneTemplates?.filter(ct => ct.status?.toUpperCase() === CONTRACT_STATUS.AGREED && !ct.warning)?.length + 1 === cloneTemplates?.length;
      const urlFromList = urlParams.get(URL_PARAMS.FROM_LIST)?.toLowerCase() === 'true';
      const urlGroupIds = urlParams.get(URL_PARAMS.GROUP_IDS)?.split(',') || [];
      const urlIncludes = urlParams.get(URL_PARAMS.INCLUDES)?.split(',') || [];
      const urlExcludes = urlParams.get(URL_PARAMS.EXCLUDES)?.split(',') || [];

      setSubmitting(true);
      setIsCongratulations(false);
      repo.submitAgreement({
        url: template.submit_url,
        templateId: template.id,
        token,
        data: {},
        params: {group_ids: urlFromList ? urlGroupIds : groupIds, is_final: urlFromList ? urlIsFinal : isFinal}
      }).then(res => {
        if (res.ok) {
          setAgreement({id: template.id, contract_url: res.data.contract_url, signed_ts: new Date(), status: CONTRACT_STATUS.AGREED, warning: false});
          if(urlFromList) {
            setChecked([]);
            setSubmitting(false);
            cloneTemplates = agreement?.templates?.map(item => {
              if(item.id === template.id) {
                return {
                  ...item,
                  contract_url: res.data.contract_url, 
                  signed_ts: new Date(), 
                  status: CONTRACT_STATUS.AGREED,
                  warning: false,
                }
              }
              return item;
            });
            const isAllSigned = !cloneTemplates?.some(ct => [CONTRACT_STATUS.NOT_YET_AGREED, CONTRACT_STATUS.EXPIRED].includes(ct.status?.toUpperCase()) || ct.warning);
            if (isAllSigned) {
              if (window.TSAMessageChannel) {
                let description = "You have completed the Technology Service Agreement renewal process. A copy of the Agreement can be found under Profile > Legal. Please press OK & you will be directed to our booking screen for available delivery opportunities.";      
                if (template.owner_types?.includes("DSP")) {
                  description = "Congratulations! You have signed the updated third party agreement. Please press OK and you continue to drive for Jitsu via your DSP.";
                }
                const json = JSON.stringify(buildMobileDialogMessage({ type: MOBILE_DIALOG_TYPE.SUCCESS, title: "Congratulations!", description, redirectTo: '/booking' }));
                window.TSAMessageChannel.postMessage(json);
              }
              else {
                const params = {
                  [URL_PARAMS.TOKEN]: token,
                  [URL_PARAMS.INCLUDES]: urlParams.get(URL_PARAMS.INCLUDES),
                  [URL_PARAMS.EXCLUDES]: urlParams.get(URL_PARAMS.EXCLUDES),
                };
                navigate(`/agreements?${createUrlParams(params)}`);
              }
              return;
            }
            const filterByCategory = filterTemplate(cloneTemplates, urlIncludes, urlExcludes);
            const isAllSignedByCategory = filterByCategory?.filter(at => at.status?.toUpperCase() === CONTRACT_STATUS.AGREED && !at.warning)?.length === filterByCategory?.length;
            setIsCongratulations(true);
            
            if(isAllSignedByCategory) {
              setMessage(template.category === CONTRACT_TYPE.PRIVACY_POLICY ? 'You also need to review and sign contract agreement' : 'You also need to review and sign Privacy Policy')
            }
            else {
              setMessage('');
            }
            return;
          }

          if (!isFinal) {
            setChecked([]);
            setSubmitting(false);
          } else if (typeof window !== 'undefined' && window.TSAMessageChannel) {
            let description = "You have completed the registration. Please press OK and you will be prompted to login momentarily to start driving for Jitsu.";
            if (redirectTo === '/booking') {
              description = "You have completed the Technology Service Agreement renewal process. A copy of the Agreement can be found under Profile > Legal > Technology Services Agreement. Please press OK & you will be directed to our booking screen for available delivery opportunities.";
              if (template.owner_types?.includes("DSP")) {
                description = "Congratulations! You have signed the updated third party agreement. Please press OK and you continue to drive for Jitsu via your DSP.";
              }
            }
            if (redirectTo === '/tsa') {
              description = "Your contract has been signed!";
            }

            const json = JSON.stringify(buildMobileDialogMessage({
              type: MOBILE_DIALOG_TYPE.SUCCESS,
              title: "Congratulations!",
              description,
              redirectTo
            }));
            window.TSAMessageChannel.postMessage(json);
          }
        } else {
          if (res.status == null || res.problem === "NETWORK_ERROR" || res.status === 401 || res.status === 403) {
            // network error
          } else if (typeof window !== 'undefined' && window.TSAMessageChannel) {
            const json = JSON.stringify(buildMobileDialogMessage({
              type: MOBILE_DIALOG_TYPE.ERROR,
              title: "ERROR!",
              description: "Some errors happened while submitting your request. Please check your connection and try again!",
              redirectTo: "/back"
            }));
            window.TSAMessageChannel.postMessage(json);
          } else {
            // no-dd-sa:javascript-best-practices/no-alert
            alert("ERROR");
          }

          setSubmitting(false);
        }

        if (submitCallback) submitCallback(res);
      })
    } else {
      // no-dd-sa:javascript-best-practices/no-alert
      alert("You must agree first!")
    }
  }

  if (loading) {
    return (
      <Box textAlign="center"><LinearProgress color="success" /></Box>
    )
  }

  const handleOk = () => {
    setChecked([]);
    setMessage('')
    setIsCongratulations(false);

    const params = {
      [URL_PARAMS.TOKEN]: token,
      [URL_PARAMS.INCLUDES]: urlParams.get(URL_PARAMS.INCLUDES),
      [URL_PARAMS.EXCLUDES]: urlParams.get(URL_PARAMS.EXCLUDES),
      [URL_PARAMS.APP_VERSION]: apps.app_version,
    };
    navigate(`/agreements?${createUrlParams(params)}`);
  }

  const canViewPdf = template.pdf_url?.includes('X-Amz-Signature');

  if (!template || (!template.html && !canViewPdf)) {
    return (
      <Box>Fail to load document!</Box>
    )
  }

  return (
    <StyledContainer>
      <Box>
        {canViewPdf && <PDFViewer url={template.pdf_url} onLoadSuccess={() => setPdfLoaded(true)} ggDocIframeStyle={{ height: 'calc(100vh - 50px)' }} />}

        {!canViewPdf && template.html && (
          <div dangerouslySetInnerHTML={{__html: template.html}} />
        )}
      </Box>
      <Box mt={1}>
        {pdfLoaded && template.checkboxes && template.checkboxes.map((text, i) => (
          <Box key={text}>
            <FormControlLabel
              label={<strong>{text}</strong>}
              control={<Checkbox checked={checked.includes(i)}
                                 onChange={e => handleCheckbox(e, i)}
                                 color="primary"
                                 name="agree-checked" />
              }
            />
          </Box>
        ))}
        <StyledActions>
          <StyledAgreeButton disabled={!isAgree() || submitting || !pdfLoaded}
                  onClick={() => onSubmit(template)}
                  fullWidth
                  disableElevation
                  variant="contained"
                  color="primary"
          >
            {!submitting ? (template.submit_text || "I Agree") : <CircularProgress color="primary" size={24} />}
          </StyledAgreeButton>
        </StyledActions>
      </Box>

      <AxlDialog
        title={'Congratulations'}
        content={<StyledTypoCongratulations textAlign='center'>{`Your contract has been signed! ${message}`}</StyledTypoCongratulations>}
        handleOk={handleOk}
        isOpen={isCongratulations}/>
    </StyledContainer>
  )
}

export default Documentation;
